import { captureException } from '@sentry/react';

export type SignatureOperation = 'upload' | 'download' | 'render' | 'generate' | 'load';

interface ReportSignatureErrorArgs {
  feature: 'esign' | 'pdf-sign';
  operation: SignatureOperation;
  fieldKey: string;
  formId?: string;
}

/** Reports failures with field/form context only. Never pass signature data, names, or file contents here. */
export const reportSignatureError = (
  error: unknown,
  { feature, operation, fieldKey, formId }: ReportSignatureErrorArgs
) => {
  captureException(error, {
    tags: { feature: `digital-forms-${feature}`, operation },
    extra: { fieldKey, formId },
  });
};
